import React from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Typography from '../../../UniformComponents/Typography'

const SectionSummary = observer(({ store }) => (
    <div className="pp-section-header-layout">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', height: '100%', width: '100%', padding: 60 }}>
            <Typography type="h4" style={{ color: 'white' }}>{i18n.t('powerpoint.slide.auto-commentary')}</Typography>

            <br />

            <Typography type="h2" color="white">{store.activeSlide.title}</Typography>
        </div>
    </div>
))

export default SectionSummary
